import { useEffect } from 'react';
import { useFeatureService } from '../context/portal-context';
import {
	DisclaimerType,
	RegisteredDisclaimers,
	getDisclaimerText,
	isStandardReferenceDisclaimer,
} from '../helpers/disclaimers/disclaimers-utils';

export const useDisclaimerReference = (disclaimers: DisclaimerType[] | undefined): void => {
	const disclaimerManager = useFeatureService()['disclaimer-manager'].getScopedDisclaimerManager();

	const registerDisclaimer = (disclaimer: DisclaimerType, registeredDisclaimersMap: RegisteredDisclaimers) => {
		const text = getDisclaimerText(disclaimer);

		if (!text) {
			return;
		}

		if (isStandardReferenceDisclaimer(disclaimer)) {
			const reference = disclaimerManager.registerReferenceDisclaimer('footer-reference', text);

			registeredDisclaimersMap[text] = {
				text: disclaimer,
				ref: reference,
				type: 'legal',
			};
		} else {
			if (disclaimer.ref) {
				const reference = disclaimerManager.registerReferenceDisclaimer('footer-reference', text, disclaimer.ref);

				registeredDisclaimersMap[text] = {
					text: disclaimer.text,
					ref: reference,
					type: 'legal',
				};
			} else {
				disclaimerManager.registerGlobalDisclaimer(text);

				registeredDisclaimersMap[text] = {
					text: disclaimer.text,
					ref: undefined,
					type: 'legal',
				};
			}
		}
	};

	const handlePropsChange = (registeredDisclaimersMap: RegisteredDisclaimers): void => {
		if (disclaimers) {
			disclaimers.forEach((disclaimer) => registerDisclaimer(disclaimer, registeredDisclaimersMap));
		}
	};

	useEffect(() => {
		const registeredDisclaimersMap: RegisteredDisclaimers = {};

		handlePropsChange(registeredDisclaimersMap);
	}, [disclaimers]);
};

// export const useDisclaimerReference = () => {
// 	const { disclaimerManager } = useContext(PortalContext);
// 	return disclaimerManager.getScopedDisclaimerManager().getFooterDisclaimers().reference;
// };
